import { PLAYER } from "../../../common/constants.ts";
import type { Conditions } from "../../../common/types.ts";
import { last } from "../../../common/utils.ts";
import { idb } from "../../db/index.ts";
import { g, helpers, logEvent } from "../../util/index.ts";

// Called with the MLB injury countdown, once a complete simulation day is saved.
// Minor-league games are not required, so recovery continues during the playoffs.
const healMinorLeagueInjuries = async (conditions: Conditions) => {
	const healedTexts: string[] = [];
	const players = await idb.cache.players.indexGetAll("playersByTid", PLAYER.MINORS);
	for (const p of players) {
		let changed = false;
		if (p.injury.gamesRemaining > 0) {
			p.injury.gamesRemaining -= 1;
			changed = true;
		}
		if (p.injury.type !== "Healthy" && p.injury.gamesRemaining <= 0) {
			const score = p.injury.score;
			p.injury = { type: "Healthy", gamesRemaining: 0 };
			changed = true;
			const healedText = `${last(p.ratings).pos} <a href="${helpers.leagueUrl(["player", p.pid])}">${p.firstName} ${p.lastName}</a> (Minors)`;
			if (p.minorTid === g.get("userTid")) healedTexts.push(healedText);
			logEvent({
				type: "healed",
				text: `${healedText} has recovered from ${helpers.pronoun(g.get("gender"), "his")} injury.`,
				showNotification: false,
				pids: [p.pid],
				tids: p.minorTid === undefined ? [] : [p.minorTid],
				score,
			}, conditions);
		}
		if (changed) await idb.cache.players.put(p);
	}
	return healedTexts;
};

export default healMinorLeagueInjuries;
